import { render } from "./LanguageDropdown.vue?vue&type=template&id=54978385"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=54978385&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__